export default __webpack_public_path__ + "static/PH-Summer-Sale-Homepage-Banner-Mobile-a04ccacf6ea2d8c3542e02c38fe47380.webp";